import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(27, 27, 27, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  width: 494px;
  max-width: 90vw;
  max-height: 90vh;
  overflow: auto;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 0 24px;
  position: relative;
`;

export const AlertIcon = styled.div`
  width: 65px;
  height: 65px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 16px auto 0 auto;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #3D3D3D;
  z-index: 10;

  img {
    width: 24px;
    height: 24px;
  }

  &:hover {
    opacity: 0.7;
  }
`;

export const ModalTitle = styled.h2`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 1em;
  color: #3D3D3D;
  text-align: center;
  margin: 16px 0 0 0;
`;

export const ModalContent = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ModalMessage = styled.p`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #3D3D3D;
  text-align: center;
  margin: 0;

  strong {
    font-weight: 500;
  }
`;

export const TextAreaContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 156px;
  padding: 16px;
  border: 1px solid #CBCBCB;
  border-radius: 8px;
  font-family: 'Mangueira', sans-serif;
  font-size: 16px;
  line-height: 1.6110351085662842em;
  color: #3D3D3D;
  resize: vertical;
  outline: none;
  box-sizing: border-box;

  &::placeholder {
    color: #929292;
    font-weight: 400;
  }

  &:focus {
    border-color: #0B29FB;
  }
`;

export const CharacterCounter = styled.div`
  position: absolute;
  right: 16px;
  bottom: 13px;
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.6110350745064872em;
  color: #929292;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 18px;
`;

export const NoButton = styled.button`
  padding: 13px 45px;
  background: #FFFFFF;
  border: 1px solid #3D3D3D;
  border-radius: 5px;
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.5420000553131104em;
  color: #3D3D3D;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1;

  &:hover {
    background: #f5f5f5;
  }
`;

export const SendButton = styled.button`
  width: 447px;
  height: 40px;
  opacity: 1;
  gap: 7px;
  border-radius: 5.33px;
  background: #0B29FB;
  border: 1px solid #0B29FB;
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.5420000553131104em;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: #0922e6;
    border-color: #0922e6;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #0B29FB;
    border-color: #0B29FB;
  }
`;

export const ValidationMessageError = styled.div`
  font-size: 12px;
  color: #D32F2F;
  margin-bottom: 16px;
`;

export const ValidationMessageInfo = styled.div`
  font-size: 12px;
  color: #999;
  margin-bottom: 16px;
`;
